var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCloseRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9594 3.70694C12.1384 3.88593 12.1534 4.16682 12.0042 4.36283L11.9595 4.41404L8.54232 7.83237L11.9615 11.2515C12.1567 11.4468 12.1567 11.7634 11.9615 11.9586C11.7825 12.1376 11.5015 12.1525 11.3056 12.0034L11.2544 11.9586L7.83522 8.53947L4.41892 11.9577C4.2237 12.153 3.90707 12.1531 3.71181 11.9578C3.53282 11.7789 3.51781 11.498 3.66693 11.3019L3.71167 11.2507L7.12811 7.83237L3.7109 4.41515C3.51564 4.21989 3.51564 3.90331 3.7109 3.70805C3.88989 3.52906 4.17082 3.51414 4.3668 3.6633L4.41801 3.70805L7.83522 7.12526L11.2523 3.70708C11.4475 3.51178 11.7641 3.51167 11.9594 3.70694Z",
    fill: "#D64C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseRed);
export default __webpack_public_path__ + "static/media/icon-close-red.966eaddf4ad8d7663de4650c915591f1.svg";
export { ForwardRef as ReactComponent };